import { render, staticRenderFns } from "./MobileTableItem.vue?vue&type=template&id=5d7e2a3f&scoped=true"
import script from "./MobileTableItem.vue?vue&type=script&lang=js"
export * from "./MobileTableItem.vue?vue&type=script&lang=js"
import style0 from "./MobileTableItem.vue?vue&type=style&index=0&id=5d7e2a3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e2a3f",
  null
  
)

export default component.exports